import type { ComponentProps } from 'react';

const BlacklistedHospital = (props: ComponentProps<'svg'>) => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon" clip-path="url(#clip0_103_32190)">
      <g id="Group 10806">
        <path
          id="Vector"
          d="M39.833 26.8723H8.49951V39.539H39.833V26.8723Z"
          fill="#8C98AB"
        />
        <path
          id="Vector_2"
          d="M43.833 39.5393H4.49951V43.5393H43.833V39.5393Z"
          fill="#55657D"
        />
        <path
          id="Vector_3"
          d="M34.4998 8.87231H13.833V39.539H34.4998V8.87231Z"
          fill="#C5CCD6"
        />
        <g id="Group 10796">
          <path
            id="Vector_4"
            d="M19.963 23.2009H17.3774V26.6504H19.963V23.2009Z"
            fill="#55657D"
          />
          <path
            id="Vector_5"
            d="M19.963 16.8723H17.3774V20.3218H19.963V16.8723Z"
            fill="#55657D"
          />
          <path
            id="Vector_6"
            d="M25.3121 23.2009H22.7266V26.6504H25.3121V23.2009Z"
            fill="#55657D"
          />
          <path
            id="Vector_7"
            d="M25.3121 16.8723H22.7266V20.3218H25.3121V16.8723Z"
            fill="#55657D"
          />
          <path
            id="Vector_8"
            d="M30.4822 23.2009H27.8967V26.6504H30.4822V23.2009Z"
            fill="#55657D"
          />
          <path
            id="Vector_9"
            d="M30.4822 16.8723H27.8967V20.3218H30.4822V16.8723Z"
            fill="#55657D"
          />
          <path
            id="Vector_10"
            d="M19.963 29.2356H17.3774V32.6851H19.963V29.2356Z"
            fill="#55657D"
          />
          <path
            id="Vector_11"
            d="M25.3121 29.2356H22.7266V32.6851H25.3121V29.2356Z"
            fill="#55657D"
          />
          <path
            id="Vector_12"
            d="M30.4822 29.2356H27.8967V32.6851H30.4822V29.2356Z"
            fill="#55657D"
          />
        </g>
        <path
          id="Vector_13"
          d="M27.7247 35.2705H20.1016V40.9878H27.7247V35.2705Z"
          fill="#55657D"
        />
        <g id="Group 10797">
          <path
            id="Vector_14"
            d="M29.2177 9.23099C29.2177 12.0064 26.9678 14.2562 24.1924 14.2562C21.417 14.2562 19.1672 12.0064 19.1672 9.23099C19.1672 6.45562 21.417 4.20573 24.1924 4.20573C26.9678 4.20573 29.2177 6.45562 29.2177 9.23099Z"
            fill="#FEF7EB"
            stroke="#DE6257"
            strokeWidth="1.33334"
          />
          <path
            id="Vector_15"
            d="M25.2281 6.64551H23.1571V11.6514H25.2281V6.64551Z"
            fill="#E06257"
          />
          <path
            id="Vector_16"
            d="M26.6256 8.18921H21.6198V10.2602H26.6256V8.18921Z"
            fill="#E06257"
          />
        </g>
        <g id="Group 10807">
          <path
            id="Vector_17"
            d="M49.3818 26.6055L49.7103 25.6442L48.7439 25.3308C46.6122 24.6397 44.3769 22.9895 42.623 21.4352C41.7586 20.6692 41.0352 19.9483 40.5283 19.4193C40.2752 19.1551 40.0769 18.9396 39.9429 18.7914C39.8759 18.7173 39.8251 18.6601 39.7916 18.6221L39.7544 18.5798L39.7459 18.57L39.7442 18.568L39.7442 18.568L39.7441 18.5678L39.744 18.5678L38.841 17.5196L38.1291 18.7062L38.1057 18.7452C38.1054 18.7457 38.1052 18.7461 38.1049 18.7466C37.8046 19.243 34.8353 23.9594 30.2477 26.0484L29.4785 26.3986L29.6957 27.2154L30.6621 26.9584C29.6957 27.2154 29.6958 27.2158 29.6959 27.2161L29.6961 27.217L29.6967 27.2193L29.6986 27.2263L29.705 27.2495C29.7104 27.269 29.7181 27.2964 29.7281 27.3313C29.7482 27.4012 29.7777 27.501 29.8171 27.627C29.8957 27.8788 30.0138 28.2361 30.1745 28.6679C30.4951 29.5295 30.9892 30.6987 31.6836 31.9242C33.0497 34.3356 35.304 37.1621 38.7177 38.0568C38.9212 38.1108 39.1312 38.1577 39.3442 38.1978L39.5588 38.2383L39.7707 38.1856C45.2935 36.8117 47.4375 32.2944 49.3818 26.6055Z"
            fill="#E06257"
            stroke="white"
            strokeWidth="2"
          />
          <path
            id="Vector_18"
            d="M48.4368 26.2823C46.4886 31.9826 44.4875 35.9823 39.5306 37.2153C39.3386 37.1791 39.1521 37.1374 38.974 37.0901V19.2571L38.999 19.2153C38.999 19.2153 43.7666 24.7681 48.4368 26.2823Z"
            fill="#B43432"
          />
          <g id="Group 10808">
            <path
              id="Union"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M43.0838 31.9132L41.7228 33.4241L39.0369 30.6797L36.3509 33.4243L34.99 31.9134L36.3138 30.6396L37.6555 29.2681L34.9214 26.4744L36.3331 25.0923L39.0369 27.8561L41.7406 25.0925L43.1523 26.4745L40.4184 29.2681L41.7599 30.6394L43.0838 31.9132Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_103_32190">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default BlacklistedHospital;
